import classNames from 'classnames';
import React from 'react';

interface Props {
  warnings: Array<string>;
  errors: Array<string>;
  children: React.ReactNode;
}

function AssemblyErrorIndicator(props: Props): JSX.Element {
  const classes = classNames('assembly-error-indicator', 'assembly-check', {
    warning: props.warnings.length > 0 && props.errors.length === 0,
    error: props.errors.length > 0,
    success: props.warnings.length + props.errors.length === 0,
  });
  return <div className={classes}>{props.children}</div>;
}

export default AssemblyErrorIndicator;
